/**
 * Hook to fetch visible counties from the API
 */

import { useState, useEffect } from 'react';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

interface County {
  id: string;
  name: string;
}

export function useCounties() {
  const [counties, setCounties] = useState<County[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchCounties() {
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/counties`);
        if (!response.ok) {
          throw new Error('Failed to fetch counties');
        }
        const data = await response.json();
        setCounties(data.counties || []);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'));
      } finally {
        setLoading(false);
      }
    }

    fetchCounties();
  }, []);

  return { counties, loading, error };
}
